(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const narrow = matchMedia('(max-width: 720px)');
  let paused = reduced.matches;
  let raf = 0;
  const videos = new Map();
  let stories = [];
  let parallax = [];
  const clamp = n => Math.max(0, Math.min(1, n));
  const updateMotionButton = () => document.querySelectorAll('[data-motion]').forEach(b => {b.setAttribute('aria-pressed', String(paused)); b.textContent = paused ? 'Activar movimiento' : 'Pausar movimiento';});
  const renderScroll = () => {
    raf = 0;
    if (paused || reduced.matches) return;
    const height = innerHeight;
    stories.forEach(story => {
      const rect = story.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > height) return;
      const p = clamp(-rect.top / Math.max(1, rect.height - height));
      const stage = story.querySelector('.story-stage');
      stage.style.setProperty('--progress',p.toFixed(4));
      const index = Math.min(2, Math.floor(p * 3));
      story.querySelectorAll('.story-beat').forEach((el,i)=>el.classList.toggle('is-active',index === i));
      const number = story.querySelector('[data-story-number]'); if(number) number.textContent=String(index+1);
    });
    parallax.forEach(el => {
      const rect=el.getBoundingClientRect();
      if(rect.bottom<0||rect.top>height)return;
      const offset=Math.max(-28,Math.min(28,(height/2-rect.top-rect.height/2)*Number(el.dataset.parallax)));
      el.style.transform=`translate3d(0,${offset.toFixed(2)}px,0)`;
    });
  };
  const schedule = () => {if(!raf)raf=requestAnimationFrame(renderScroll);};
  const playVisible = () => {
    const eligible=[...videos].filter(([video,state])=>state.ratio>.35&&!state.userPaused);
    eligible.sort((a,b)=>b[1].ratio-a[1].ratio);
    const active = narrow.matches ? eligible.slice(0,1) : eligible;
    videos.forEach((state,video) => {
      const allow=!paused&&!reduced.matches&&!document.hidden&&!navigator.connection?.saveData&&active.some(([v])=>v===video);
      if(!allow){video.pause();return;}
      if(!video.dataset.loaded){video.querySelectorAll('source[data-src]').forEach(source=>source.src=source.dataset.src);video.load();video.dataset.loaded='true';}
      if(video.paused)video.play().catch(()=> {state.button.textContent='▶';state.button.setAttribute('aria-label','Reproducir vídeo');});
    });
  };
  const observe = new IntersectionObserver(entries=>{entries.forEach(entry=>{const state=videos.get(entry.target);if(state)state.ratio=entry.intersectionRatio;});playVisible();},{threshold:[0,.2,.35,.5,.75,1]});
  const setPaused = value => {paused=value;document.documentElement.classList.toggle('motion-paused',paused);updateMotionButton();playVisible();schedule();};
  function init(root=document) {
    stories=[...document.querySelectorAll('[data-scroll-story]')];parallax=[...document.querySelectorAll('[data-parallax]')];
    root.querySelectorAll('[data-video]').forEach(video=>{
      if(videos.has(video))return;
      const button=video.closest('.film-card').querySelector('.film-control');
      const state={ratio:0,userPaused:false,button};videos.set(video,state);observe.observe(video);
      const action=()=>{
        if(paused||reduced.matches||navigator.connection?.saveData){
          if(!video.dataset.loaded){video.querySelectorAll('source[data-src]').forEach(source=>source.src=source.dataset.src);video.load();video.dataset.loaded='true';}
          if(video.paused) {videos.forEach((s,v)=>{if(v!==video&&narrow.matches)v.pause();});video.play().catch(()=>{});}else video.pause();
        }else{state.userPaused=!state.userPaused;playVisible();}
      };
      button.addEventListener('click',action);
      const sync=()=>{button.textContent=video.paused?'▶':'Ⅱ';button.setAttribute('aria-label',video.paused?'Reproducir vídeo':'Pausar vídeo');button.setAttribute('aria-pressed',String(!video.paused));};
      video.addEventListener('play',sync);video.addEventListener('pause',sync);sync();
    });
    schedule();
  }
  document.addEventListener('click',event=>{
    const level=event.target.closest('[data-level]');
    if(level){const group=level.closest('.temperature-instrument');group.querySelectorAll('[data-level]').forEach(b=>b.setAttribute('aria-pressed',String(b===level)));const num=group.querySelector('[data-level-number]');num.textContent=String(level.dataset.level).padStart(2,'0');if(!paused&&!reduced.matches)num.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:250,easing:'ease-out'});}
    const thumb=event.target.closest('[data-gallery-src]');
    if(thumb){const gallery=thumb.closest('[data-gallery]');const image=gallery.querySelector('.gallery-main img');if(image){image.src=thumb.dataset.gallerySrc;image.srcset='';image.alt=thumb.dataset.galleryAlt||'';gallery.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));if(!paused&&!reduced.matches)image.animate([{opacity:.3},{opacity:1}],{duration:300});}}
    if(event.target.closest('[data-motion]'))setPaused(!paused);
    const menu=event.target.closest('[data-menu]');if(menu){const target=document.getElementById(menu.getAttribute('aria-controls'));const expanded=menu.getAttribute('aria-expanded')==='true';menu.setAttribute('aria-expanded',String(!expanded));target.hidden=expanded;}
    if(event.target.closest('.mobile-nav a')){document.getElementById('mobile-nav').hidden=true;document.querySelector('[data-menu]').setAttribute('aria-expanded','false');}
    if(event.target.closest('[data-cart-open]'))document.getElementById('cart-preview').showModal();
    if(event.target.closest('[data-cart-close]'))document.getElementById('cart-preview').close();
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){const nav=document.getElementById('mobile-nav');if(nav&&!nav.hidden){nav.hidden=true;const b=document.querySelector('[data-menu]');b.setAttribute('aria-expanded','false');b.focus();}}});
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach((s,v)=>v.pause());else playVisible();});
  reduced.addEventListener('change',()=>setPaused(reduced.matches));
  narrow.addEventListener('change',playVisible);
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{videos.forEach((s,v)=>{if(e.target.contains(v)){v.pause();observe.unobserve(v);videos.delete(v);}});stories=stories.filter(s=>!e.target.contains(s));parallax=parallax.filter(s=>!e.target.contains(s));});
  init();setPaused(paused);
})();
